import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { HomeService } from '../services/homeservice';
import { Iassociation } from '../sidenav/helper';
import { Router } from '@angular/router';
import { DynamicTabsService } from '../dynamic-tabs.service';
import { MatSort, MatSortable, Sort } from '@angular/material/sort';

@Component({
  selector: 'app-associations',
  templateUrl: './associations.component.html',
  styleUrls: ['./associations.component.css']
})
export class AssociationsComponent {
  @Output() openDetailTab = new EventEmitter();
  @Input() id: number = 0;
  @Input() label: string = '';
  @Input() type: string = '';
  associations: Iassociation[] = [];
  searchTerm: string = '';
  filteredData: Iassociation[] = [];
  sortingColumn: string = '';
  sortOrder: 'asc' | 'desc' = 'asc';
  currentPage: number = 0;
  dataSource!: MatTableDataSource<Iassociation>;
  totalItems: number = 0;
  currentPageIndex: number = 0;
  pageSize: number = 45;
  pageSizeOptions: number[] = [45, 90, 135];
  showFirstLastButtons = true;
  isHidePageSize: boolean = true;
  isSearching: boolean = false;
  isLoading: boolean = false;
  pageIndex: number = 0;

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  columnsToDisplay: string[] = [
    'name',
    'code',
    'address1',
    'address2',
    'city',
    'stateId',
    'postalCode',
    'email',
    'mainNumber',
    'lastUpdated',
    'faxNumber',
    'notes'
  ]
  constructor(private router: Router, private service: HomeService, public dynamicTabService: DynamicTabsService) {
    this.dataSource = new MatTableDataSource<Iassociation>([]);

  }
  ngOnInit() {

    //refresh
    this.dynamicTabService.refreshObv.subscribe(value => {
      if (value && this.dynamicTabService.selectedTab == 'Associations')
        this.refresh();
    })

    this.getAssociations();
    this.loadTableData();

  }
  ngAfterViewInit() {
    this.paginator.pageSize = 45;
    this.checkRowsPerPage();
  }

  loadTableData() {
    this.isLoading = true;
    this.getAssociations();
  }

  //refresh
  refresh() {
    if (this.dynamicTabService.selectedTabData.id == -6) {
      this.isLoading = true;
      this.getAssociations();
      this.clearSearch();
      // console.log("Associations refresh");
    }
  }
  sendIdtochild(association: any) {
    this.openDetailTab.emit({ id: association.id, label: association.name, type: 'association' });
    // console.log(association.id);
    // childcomp : ev.iD
  }
  getAssociations() {
    let associations = this.service.getAssociations().subscribe((res: any[]) => {
      this.associations = res;
      this.filteredData = this.associations;
      this.totalItems = this.filteredData.length;
      this.applyPagination();
      this.isLoading = false;
      res.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        if (isNaN(Number(nameA)) && isNaN(Number(nameB))) {
          return nameA.localeCompare(nameB);
        }
        else if (!isNaN(Number(nameA)) && !isNaN(Number(nameB))) {
          return Number(nameA) - Number(nameB);
        }
        else {
          return isNaN(Number(nameA)) ? 1 : -1;
        }
      });
      this.dataSource.data = res;
      this.dataSource.sort = this.sort;
      
    });
  }

  onPageChange(event: any): void {
    this.pageSize = 45;
    this.currentPageIndex = event.pageIndex;
    this.applyPagination();
  }

  filterData(): void {
    const startIndex = this.currentPageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.filteredData = this.dataSource.data.slice(startIndex, endIndex);
  }
  applyPagination(): void {
    const startIndex = this.currentPageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.dataSource.data = this.filteredData.slice(startIndex, endIndex);
  }
  applyFilter(): void {
    this.pageSize = 45;
    this.currentPageIndex = 0;
    const searchValue = this.searchTerm.trim().toLowerCase();
    this.filteredData = this.associations.filter((item) => {
      const searchFields = [item.name, item.code, item.city, item.address1, item.address2, item.stateId, item.postalCode,
      item.email, item.mainNumber];
      return searchFields.some((field) => String(field).toLowerCase().includes(searchValue));
    });
    this.totalItems = this.filteredData.length;
    this.isSearching = searchValue != '';
    this.applyPagination();
  }

  //event listener for searching
  @HostListener('document:keyup.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.search();
    }
  }

  //checking number of rows per page
  checkRowsPerPage() {
    if (this.paginator) {
      const rowsPerPage = this.paginator.pageSize;
      // console.log(`Number of rows per page:${rowsPerPage}`);
    }
  }

 
  search(): void {
   
      this.applyFilter();
    
  }

  clearSearch(): void {
    this.pageSize = 45;
    this.currentPageIndex = 0;
    this.searchTerm = '';
    this.isSearching = false;
    this.filteredData = this.associations;
    this.totalItems = this.associations.length;
    this.applyPagination();
  }
  onAssociationClick(association: Iassociation) {
    const name = association.name;
    this.router.navigate(['/association-details'], { queryParams: { name } });
  }
  getTotalPages(): number {
    return Math.ceil(this.filteredData.length / this.pageSize);
  }

  sortData(column: keyof Iassociation) {
    if (this.sortingColumn == column) {

      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    }
    else {
      this.sortingColumn = column;
      this.sortOrder = 'asc';
    }
    this.associations.sort((a, b) => {
      const valueA = (a[column] || '').toString();
      const valueB = (b[column] || '').toString();
      //compare mixed-case values
      if (valueA.toLowerCase() < valueB.toLowerCase()) {
        return this.sortOrder === 'asc' ? -1 : 1;
      }

      else if (valueA.toLowerCase() > valueB.toLowerCase()) {
        return this.sortOrder === 'asc' ? 1 : -1;
      }

      //Handle empty values
      if (valueA === '' && valueB === '') {
        return 0;
      } else if (valueA === '') {
        return -1;
      } else if (valueB === '') {
        return 1;
      }
      return 0;

    });
    this.applyPagination();
  }
}
